import React from 'react';
import NavigationComponent from "../../commonComponents/util/NavigationComponent";
import Modal from '../../commonComponents/util/Modal';
import ValidatedInput from '../../commonComponents/util/ValidatedInput';
import Select from '../../commonComponents/util/Select';
import RadioGroup from '../../commonComponents/util/RadioGroup';
import FadeOutErrorMessage from '../../commonComponents/util/FadeOutErrorMessage';
import LoadingSpinner from '../../commonComponents/util/LoadingSpinner';
import { isValidEmail, deepEquals, locationIsIsraeli } from '../../../lib/utils';
import { CampaignListTypes } from '../../../lib/systemVariables';
import WarningModal from '../../commonComponents/shared/WarningModal';

const initialState = {
    campaignList: {},
    invalidData: false,
    error: false,
    submitAttempted: false,
    checkAssocs: true,
    showModals: {
        assocsAlertModal: false
    }
};

export default class EditCampaignListModal extends NavigationComponent {
    constructor(props) {
        super(props);

        this.state = initialState;

        this.onChange = this.onChange.bind(this);
        this.onUpdate = this.onUpdate.bind(this);
        this.onClose = this.onClose.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (!this.props.show && nextProps.campaignList) {
            this.setState({ campaignList: nextProps.campaignList });
        }
    }

    onChange(name, value) {
        this.setState({ campaignList: { ...this.state.campaignList, ...{ [name]: value } } });
    }

    async onUpdate() {
        this.setState({ error: false, submitAttempted: true });

        const campaignList = this.state.campaignList;
        if (this.state.invalidData || !campaignList.fundId
            || (campaignList.campaignListType === CampaignListTypes.External && (!campaignList.managerName || !campaignList.managerEmail))) {
            return;
        }
        
        if (this.props.campaignList.campaignListType === CampaignListTypes.External && campaignList.campaignListType === CampaignListTypes.Internal &&
            this.state.checkAssocs && campaignList.assocsSent !== null) {
            this.toggleModal('assocsAlertModal');
            return;
        }

        await this.props.updateCampaignList(this.state.campaignList);

        if (this.props.success) {
            this.onClose();
        } else {
            this.setState({ error: true });
        }
    }

    onClose() {
        this.props.close();
        this.setState(initialState);
    }

    validateEmail(email) {
        const isValid = isValidEmail(email);
        this.setState({ invalidData: !isValid });
        return isValid;
    }

    render() {
        const campaignList = this.state.campaignList;
        const hasSubmittedAssocs = campaignList.hasSubmittedAssocs;
        const assocsSent = campaignList.assocsSent;

        return (
            <Modal modalShowing={this.props.show}>
                <div className="modal-container">
                    <div className="modal large-modal">
                        <div className="modal-header">
                            <h4 className="page-header">Edit {campaignList.name}</h4>
                            <i className="icon ion-ios-close-empty" onClick={this.onClose}></i>
                        </div>
                        <div className="modal-section">
                            <div className="modal-row">
                                <div className="column-half">
                                    <RadioGroup title="Type" 
                                        name="campaignListType"
                                        options={[{ key: 'Internal', value: 'Internal', disabled: hasSubmittedAssocs}, 
                                                  { key: 'External', value: 'External', disabled:  hasSubmittedAssocs}]}
                                        value={campaignList.campaignListType}
                                        onChange={this.onChange}
                                    />
                                </div>
                                <div className="column-half">
                                    {this.props.isAdmin && 
                                        <div>
                                            <label className="empty-label" style={{marginBottom: "6px"}}/>
                                            <div className="custom-check-container">
                                                <input
                                                    type="checkbox"
                                                    id="allow-duplicates"
                                                    className="custom-check"
                                                    name="allowDuplicates"
                                                    onChange={event => this.onChange(event.target.name, event.target.checked)}
                                                    checked={campaignList.allowDuplicates} />
                                                <label htmlFor="allow-duplicates" className="secondary-text">Allow Duplicates</label>
                                            </div>
                                        </div>}
                                </div>
                            </div>
                        </div>
                        <div className="modal-section">
                            <div className="modal-row">
                                <div className="column-half">
                                    <ValidatedInput input={<Select
                                        options={locationIsIsraeli(this.props.locations, campaignList.locationId) ? this.props.ILFunds : this.props.USFunds} />}
                                        label="Fund" name="fundId" value={campaignList.fundId} onChange={this.onChange}
                                        required={true} showRequiredError={this.state.submitAttempted} />
                                </div>
                                <div className="column-half">
                                    {campaignList.campaignListType === CampaignListTypes.External &&
                                     <div>
                                     <label className="empty-label" style={{marginBottom: "6px"}}/>
                                        <div className="custom-check-container">
                                            <input
                                                disabled //TODO - for now disabling update to batch always.  potentially would want to enable if no participants yet added of the list. 
                                                type="checkbox"
                                                id="batch-list"
                                                className="custom-check"
                                                name="batch"
                                                onChange={event => this.onChange(event.target.name, event.target.checked)}
                                                checked={campaignList.batch} />
                                            <label htmlFor="batch-list" className="secondary-text">Batch</label>
                                        </div></div>}
                                </div>
                            </div>
                        </div>
                        <WarningModal
                            show={this.state.showModals.assocsAlertModal}
                            close={() => this.toggleModal("assocsAlertModal")}
                            message={`You modified this list from an external to internal list. \n This campaign list has external associations to the following campaigns: \n ${assocsSent}\n 
                            You will have to add this campaign list to the campaign(s) again.`}
                            continue={() => {
                                this.setState({ checkAssocs: false }, this.onUpdate);
                            }} />
                        {campaignList.campaignListType === CampaignListTypes.External &&
                            <div className="modal-section">
                                <div className="modal-row">
                                    <div className="column-half">
                                        <ValidatedInput input={<input type="text" />}
                                            label="Manager Name" name="managerName" value={campaignList.managerName || ''} onChange={this.onChange}
                                            required={true} showRequiredError={this.state.submitAttempted} />
                                    </div>
                                    <div className="column-half">
                                        <ValidatedInput input={<input type="text" />}
                                            label="Manager Email" name="managerEmail" value={campaignList.managerEmail || ''} onChange={this.onChange}
                                            required={true} showRequiredError={this.state.submitAttempted}
                                            validated={true} showValidationError={true} validate={this.validateEmail.bind(this)}
                                            errorMessage="Invalid Email Address" />
                                    </div>
                                </div>
                            </div>}
                        {this.props.loading ? <LoadingSpinner height="20" alignRight={true} /> :
                            <div className="modal-btns text-right">
                                <button className="btn btn-accent" onClick={this.onClose}>Cancel</button>
                                <button className="btn btn-primary" onClick={this.onUpdate}
                                    disabled={this.state.invalidData || deepEquals(this.props.campaignList, this.state.campaignList)}>Update</button>
                                <FadeOutErrorMessage show={this.state.error} />
                            </div>}
                    </div>
                </div>
            </Modal>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/campaignComponents/campaignListDetails/EditCampaignListModal.jsx